module.exports = __webpack_public_path__ + "static/media/ir.6d32f579.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ir.svg
// module id = 153
// module chunks = 0